import React from 'react';

const Svg = (props) => (
  <svg {...props} viewBox="0 0 20 20"><path d="M13.014 2.015a2 2 0 0 1 2.829 0l2.142 2.142a2 2 0 0 1 0 2.828l-2.142 2.142a2 2 0 0 1-2.829 0l-2.142-2.142a2 2 0 0 1 0-2.828l2.143-2.142Zm-9.585.577a2 2 0 0 0-2 2v3.99a2 2 0 0 0 2 2h3.99a2 2 0 0 0 2-2v-3.99a2 2 0 0 0-2-2h-3.99Zm7.99 7.99a2 2 0 0 0-2 2v3.99a2 2 0 0 0 2 2h3.989a2 2 0 0 0 2-2v-3.99a2 2 0 0 0-2-2h-3.99Zm-9.99 2.998a2 2 0 0 1 2-2h2.99a2 2 0 0 1 2 2v2.991a2 2 0 0 1-2 2H3.43a2 2 0 0 1-2-2v-2.99Z" clip-rule="evenodd" fill-rule="evenodd" data-follow-fill="currentColor" fill="currentColor"></path></svg>
);

export default Svg;
